/**
 * @file Singleton which collapses desktop navigation if viewport height is too narrow
 *
 * @author christian.sany@notch-interactive.com
 */

import resizeManager from '../helpers/resize-manager';
import debounce from 'debounce';

let isSmallDueToPlugin = false;

const checkViewport = () => {
    if (!isSmallDueToPlugin && window.innerWidth >= 768 && window.innerHeight < 500) {
        document.body.classList.add('navigation--prepare', 'navigation--prepareafter', 'navigation--small');
        isSmallDueToPlugin = true;
    } else if (isSmallDueToPlugin && window.innerWidth >= 768 && window.innerHeight >= 500) {
        document.body.classList.remove('navigation--prepare', 'navigation--prepareafter', 'navigation--small');
        isSmallDueToPlugin = false;
    }
};

resizeManager.add(debounce(checkViewport, 150));
